export type SizeUnit = string | number;

/**
 * Requires toast container to have class .hermes-toast-container
 */
export const isToast = (element: Element) => {
  return element.closest(".hermes-toast-container") !== null;
};
